import { render, staticRenderFns } from "./fontsSettingsHeading.vue?vue&type=template&id=813c5ac0&scoped=true&"
import script from "./fontsSettingsHeading.vue?vue&type=script&lang=js&"
export * from "./fontsSettingsHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813c5ac0",
  null
  
)

export default component.exports